const SITE_NAME_SUFFIX = ' - Fleequid';

// Search engines cut the title link on pixel width, ~60 latin characters. The site name is the first thing
// to drop when the budget is tight: it carries the least information and Google already shows it on its own row.
const TITLE_MAX_LENGTH = 60;

export const withSiteName = (title: string): string => {
    const titleWithSiteName = `${title}${SITE_NAME_SUFFIX}`;

    return titleWithSiteName.length > TITLE_MAX_LENGTH ? title : titleWithSiteName;
};
